module.exports = __webpack_public_path__ + "img/pic_gongxvtong.fcefdcae.svg";